import React from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import LogoHeader from "../LogoHeader";

const Header = () => {
  const navigate = useNavigate();

  return (
    <div className="create-header row">
      <div className="back-container row" onClick={() => navigate("/")}>
        <svg
          className="back-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M12.5 5L7.5 10L12.5 15"
            stroke="#5C45EB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <p>Back</p>
      </div>
      <LogoHeader variant="header" direction="horizontal" />
    </div>
  );
};

export default Header;